import DOMPurify from 'dompurify';

// Apenas https:// e http:// — bloqueia javascript:, data:, etc.
const SAFE_URI = /^(?:(?:https?):\/\/)/i;

/**
 * Sanitiza HTML restritivo — para conteudo de USUARIOS (comentarios, debates).
 * Permite apenas formatacao basica de texto e links.
 */
export const sanitizeHtml = (html: string): string => {
  if (!html) return '';

  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'i', 'b', 'a', 'ul', 'ol', 'li', 'span'],
    ALLOWED_ATTR: ['href', 'target', 'rel'],
    ALLOWED_URI_REGEXP: SAFE_URI,
  });
};

/**
 * Sanitiza HTML permissivo — para conteudo EDITORIAL (artigos, quizzes, termos, descricoes de curso).
 * Permite iframes (YouTube, PandaVideo), imagens, tabelas e formatacao rica.
 */
export const sanitizeRichContent = (html: string): string => {
  if (!html) return '';

  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      // texto
      'p', 'br', 'strong', 'em', 'u', 'i', 'b', 'a', 'span', 'big', 'small', 'sub', 'sup',
      // listas
      'ul', 'ol', 'li',
      // headings
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      // midia
      'img', 'figure', 'figcaption', 'iframe', 'video', 'source',
      // estrutura
      'div', 'blockquote', 'pre', 'code', 'hr',
      // tabelas
      'table', 'thead', 'tbody', 'tfoot', 'tr', 'th', 'td', 'caption',
    ],
    ALLOWED_ATTR: [
      'href', 'target', 'rel',
      'src', 'alt', 'width', 'height', 'loading',
      'class',
      'allow', 'allowfullscreen', 'frameborder', 'title',
      'colspan', 'rowspan', 'scope',
    ],
    ALLOWED_URI_REGEXP: SAFE_URI,
  });
};

/**
 * Remove todas as tags HTML — para contextos onde so queremos texto puro.
 * Substitui o regex inseguro de truncateHTML em lib/string.ts.
 */
export const stripHtml = (html: string): string => {
  if (!html) return '';
  return DOMPurify.sanitize(html, { ALLOWED_TAGS: [] });
};

/**
 * Trunca texto e sanitiza — para previews e cards.
 */
export const sanitizeAndTruncate = (text: string | undefined, maxLength: number): string => {
  if (!text) return '';

  const clean = stripHtml(text);
  return clean.length > maxLength ? `${clean.substring(0, maxLength)}[...]` : clean;
};